import { AppState } from './interfaces';
import { createReducer } from 'typesafe-actions';

const stateKey = 'app';

/* ------------- Initial State ------------- */
const INITIAL_STATE: AppState = {};

/* ------------- Reducers ------------- */

/* ------------- Hookup Reducers To Types ------------- */
const reducer = createReducer(INITIAL_STATE, {});

const reducerMap = { [stateKey]: reducer };

/* ------------- Selectors ------------- */
const selectors = {};

/* ------------- Export ------------- */
export default {
    // default export
    selectors,
    INITIAL_STATE,
    stateKey,
    reducer,
    reducerMap,
};
